import styled, { keyframes } from 'styled-components';

import { AlertType, SKEW_ANGLE } from '@utils/constants';

const slideIn = keyframes`
  from {
    transform: translateX(100%) skewX(-${SKEW_ANGLE}deg);
    opacity: 0;
  }
  to {
    transform: translateX(0) skewX(-${SKEW_ANGLE}deg);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0) skewX(-${SKEW_ANGLE}deg);
  }
  to {
    opacity: 0;
    transform: translateX(100%) skewX(-${SKEW_ANGLE}deg);
  }
`;

export const Container = styled.div<{
  $variant: AlertType;
  $isExiting: boolean;
}>`
  max-width: 280px;
  margin: 0;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid
    ${({ theme, $variant }) =>
      $variant === AlertType.Error
        ? theme.colors.red[500]
        : $variant === AlertType.Success
          ? theme.colors.green[500]
          : $variant === AlertType.Warning
            ? theme.colors.yellow[500]
            : theme.colors.blue[500]};
  transform: skewX(-${SKEW_ANGLE}deg);
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  animation: ${({ $isExiting }) => ($isExiting ? fadeOut : slideIn)} 0.3s
    ease-out forwards;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const IconWrapper = styled.div<{ $variant: AlertType }>`
  transform: skewX(${SKEW_ANGLE}deg);
  color: ${({ theme, $variant }) =>
    $variant === AlertType.Error
      ? theme.colors.red[500]
      : $variant === AlertType.Success
        ? theme.colors.green[500]
        : $variant === AlertType.Warning
          ? theme.colors.yellow[500]
          : theme.colors.blue[500]};
  display: flex;
  align-items: center;
`;

export const Message = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.fonts.fontSize.sm};
  color: ${({ theme }) => theme.colors.black};
  transform: skewX(${SKEW_ANGLE}deg);
  word-break: break-word;
`;
